import { Icons } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { validateUserAddPermission } from '@/lib/api/auth'
import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import { Header } from '@/components/header'
import MeterSizeRateForm from '@/components/forms/meter-size-rate-form'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-size-rates/add',
)()

export function AddMeterSizeRates() {
  const [showModal, setShowModal] =
      React.useState<boolean>(false)

  return (
    <main>
      <div>
        <Button
          onClick={() => {
            if (!validateUserAddPermission()) return
            setShowModal((prev) => !prev)
          }}
        >
          <Icons.add className="size-4" />
          Add Meter Size Rates
        </Button>
      </div>
      <Credenza open={showModal} onOpenChange={setShowModal}>
        <CredenzaContent className="w-full md:min-w-[800px]">
          <CredenzaHeader>
            <CredenzaTitle>
              <Header
                subroutes={[
                  {
                    route: '/meter-connection-settings/meter-size-rates',
                    label: 'Meter Size Rates',
                  },
                ]}
              >
                Add Meter Size Rates
              </Header>
            </CredenzaTitle>
          </CredenzaHeader>
          <CredenzaBody>
            <MeterSizeRateForm
              onClose={() => setShowModal(false)}
              setShowModal={setShowModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}